/**
 * 指标参数类型
 */
export enum QuotaParamsType {
  /**
   * 区间
   */
  BETWEEN = 0,
  /**
   * 大于
   */
  GT = 1,
  /**
   * 大于等于
   */
  GE = 2,
  /**
   * 等于
   */
  EQ = 3,
  /**
   * 小于
   */
  LT = 4,
  /**
   * 小于等于
   */
  LE = 5,
  /**
   * 约等于
   */
  AEQ = 6
}

export const QuotaParamsTypeMap: Record<QuotaParamsType, string> = {
  [QuotaParamsType.BETWEEN]: '区间',
  [QuotaParamsType.GT]: '大于',
  [QuotaParamsType.GE]: '大于等于',
  [QuotaParamsType.EQ]: '等于',
  [QuotaParamsType.LT]: '小于',
  [QuotaParamsType.LE]: '小于等于',
  [QuotaParamsType.AEQ]: '约等于'
}

export const QuotaParamsTypeOperationsMap: Record<QuotaParamsType, string> = {
  [QuotaParamsType.BETWEEN]: '~',
  [QuotaParamsType.GT]: '>',
  [QuotaParamsType.GE]: '≥',
  [QuotaParamsType.EQ]: '=',
  [QuotaParamsType.LT]: '<',
  [QuotaParamsType.LE]: '<',
  [QuotaParamsType.AEQ]: '≈'
}
